import { adminCall } from '../../api/adminCall';

export const setSpecialAdmin = async ({ userId, isSpecialAdmin }) => {
  return adminCall(`/api/admin/app-users/${encodeURIComponent(userId)}/special-admin`, {
    isSpecialAdmin,
  });
};
